import { Icon } from './types';

export const CalendarToday = ({ svgProps, pathProps }: Icon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="calendar-today"
    {...svgProps}
  >
    <path
      d="M22 3h-3V1h-2v2H7V1H5v2H2v20h20V3zm-2 18H4V8h16v13z"
      fill="currentColor"
      {...pathProps}
    />
  </svg>
);
